/**
 * @fileoverview Marker
 * @author dxq613@gmail.com
 */
import { __extends } from "tslib";
import { isNil } from '@antv/util';
import { path2Absolute } from '@antv/path-util';
import ShapeBase from './base';
import { isFunction } from '../util/util';
import { drawPath } from '../util/draw';
var Symbols = {
    // å
    circle: function (x, y, r) {
        return [
            ['M', x - r, y],
            ['A', r, r, 0, 1, 0, x + r, y],
            ['A', r, r, 0, 1, 0, x - r, y],
        ];
    },
    // æ­£æ¹å½¢
    square: function (x, y, r) {
        return [['M', x - r, y - r], ['L', x + r, y - r], ['L', x + r, y + r], ['L', x - r, y + r], ['Z']];
    },
    // è±å½¢
    diamond: function (x, y, r) {
        return [['M', x - r, y], ['L', x, y - r], ['L', x + r, y], ['L', x, y + r], ['Z']];
    },
    // ä¸è§å½¢
    triangle: function (x, y, r) {
        var diffY = r * Math.sin((1 / 3) * Math.PI);
        return [['M', x - r, y + diffY], ['L', x, y - diffY], ['L', x + r, y + diffY], ['Z']];
    },
    // åä¸è§å½¢
    'triangle-down': function (x, y, r) {
        var diffY = r * Math.sin((1 / 3) * Math.PI);
        return [['M', x - r, y - diffY], ['L', x + r, y - diffY], ['L', x, y + diffY], ['Z']];
    },
};
var Marker = /** @class */ (function (_super) {
    __extends(Marker, _super);
    function Marker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Marker.prototype.initAttrs = function (attrs) {
        this._resetParamsCache();
    };
    // éç½®ç»å¶ path å­å¨çç¼å­
    Marker.prototype._resetParamsCache = function () {
        // ä¸ºäºå é path çç»å¶ãæ¾ååè®¡ç®ï¼è¿ä¸ªå°æ¹å¯ä»¥ç¼å­å¾å¤ä¸è¥¿
        // è¿äºç¼å­é½æ¯ç¬¬ä¸æ¬¡éè¦æ¶è®¡ç®åå­å¨ï¼è½ç¶å¢å äºå¤æåº¦ï¼ä½æ¯é¢ç¹è°ç¨çæ¹æ³ï¼æ§è½æå¾å¤§æå
        this.set('paramsCache', {}); // æ¸çç¼å­
    };
    // æ´æ°å±æ§æ¶ï¼æ£æµæ¯å¦æ´æ¹äº path
    Marker.prototype.onAttrChange = function (name, value, originValue) {
        _super.prototype.onAttrChange.call(this, name, value, originValue);
        if (['symbol', 'x', 'y', 'r', 'radius'].indexOf(name) !== -1) {
            // path ç¸å³å±æ§æ´æ¹æ¶ï¼æ¸çç¼å­
            this._resetParamsCache();
        }
    };
    // ä»ä»ä½¿ç¨åå´çæ£æµæ¥è¿è¡æ¾å
    // æä»¥ä¸éè¦å¤å isInStrokeOrPath çæ¹æ³
    Marker.prototype.isOnlyHitBox = function () {
        return true;
    };
    Marker.prototype._getR = function (attrs) {
        // å¼å®¹ r å radius ä¸¤ç§åæ³ï¼æ¨èä½¿ç¨ r
        return isNil(attrs.r) ? attrs.radius : attrs.r;
    };
    Marker.prototype._getPath = function () {
        var attrs = this.attr();
        var x = attrs.x, y = attrs.y;
        var symbol = attrs.symbol || 'circle';
        var r = this._getR(attrs);
        var method;
        var path;
        if (isFunction(symbol)) {
            method = symbol;
            path = method(x, y, r);
            // å° path è½¬æç»å¯¹è·¯å¾
            path = path2Absolute(path);
        }
        else {
            // åç½® symbol ç path é½æ¯ç»å¯¹è·¯å¾ï¼ç´æ¥ç»å¶å³å¯ï¼ä¸éè¦å¯¹ path è¿è¡ç¹æ®å¤ç
            method = Marker.Symbols[symbol];
            if (!method) {
                console.warn(symbol + " marker is not supported.");
                return null;
            }
            path = method(x, y, r);
        }
        return path;
    };
    Marker.prototype.createPath = function (context) {
        var path = this._getPath();
        var paramsCache = this.get('paramsCache');
        drawPath(this, context, { path: path }, paramsCache);
    };
    Marker.Symbols = Symbols;
    return Marker;
}(ShapeBase));
export default Marker;
//# sourceMappingURL=marker.js.map